<template>
  <b-col sm="12" lg="8" :class="{'safari-only':is_safari()}">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <strong style="font-size:20px">Top 10 Diagnosis</strong>
          </div>
          <div class="col-sm-7 offset-sm-1">
            <div class="row">
              <div class="col-8">
                <div class="form-group row">
                  <label class="col-sm-4 offset-sm-2 col-form-label col-form-label-sm pr-1"><strong>Pilih Periode:</strong></label>
                  <div class="col-sm-6 px-1">
                    <month-picker-input
                      date-format="%n %Y"
                      :default-month="default_month"
                      :default-year="default_year"
                      :input-pre-filled="true"
                      :max-date="max_date"
                      :min-date="min_date"
                      lang="id"
                      @input="input_periode"
                    ></month-picker-input>
                  </div>
                </div>
              </div>
              <div class="col pl-1">
                <button class="btn btn-primary btn-block btn-sm text-capitalize" @click="download">Download</button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-diagnosis">
            <thead>
              <tr>
                <th rowspan="2" class="text-center align-top" style="min-width:110px;">Kode</th>
                <th rowspan="2" class="text-center align-top" style="min-width:270px;">Nama Penyakit</th>
                <th v-for="(header, index) in header_table" :key="index" colspan="2" v-html="header" class="text-center border-l"></th>
                <th colspan="2" class="text-center border-l sticky r-100">Jumlah</th>
                <th rowspan="2" class="text-center align-top border-l sticky r-0" style="min-width:100px;">Total</th>
              </tr>
              <tr>
                <th v-for="(subheader, index) in subheader_table" :key="index" style="min-width:62px;" class="text-center" :class="index%2==0?'border-l':''">{{subheader}}</th>
                <th style="min-width:62px;" class="text-center sticky r-162 border-l">L</th>
                <th style="min-width:62px;" class="text-center sticky r-100">P</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, idx) in data_table" :key="`${data.id}_${idx}`">
                <td>{{ data.kode }}</td>
                <td>{{ data.description }}</td>
                <td v-for="(x, i) in data.data" :key="i" class="text-center" :class="i%2==0?'border-l':''">{{ x }}</td>
                <td class="text-center sticky r-162 border-l">{{ data.total_l }}</td>
                <td class="text-center sticky r-100">{{ data.total_p }}</td>
                <td class="text-center sticky r-0 border-l">{{ data.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>;
import moment from 'moment';
import { mapGetters } from "vuex";
import { MonthPickerInput } from 'vue-month-picker';
export default {
  data() {
    return {
      periode_dt: null,
      periode_name: '',
      header_table: [],
      subheader_table: [],
      data_table: [],
      max_date: null,
      min_date: null,
      default_month: null,
      default_year: null,
    };
  },
  components: {
    MonthPickerInput,
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId"
    })
  },
  mounted() {
    this.fetchTopDiagnosis();

    let dt = new Date();
    this.max_date = dt;
    this.periode_dt = dt;
    this.default_month = dt.getMonth() + 1;
    this.default_year = dt.getFullYear();
    this.periode_name = moment(dt).locale('id').format('MMMM YYYY');

    let dt_min = new Date('2021-10-01T00:00:00');
    this.min_date = dt_min;
  },
  methods: {
    fetchTopDiagnosis() {

      let params = {
        klinik_id: this.getKlinikId
      };

      if(this.periode_dt) {
        params.year = this.periode_dt.getFullYear();
        params.month = ((this.periode_dt.getMonth() + 1) + '').padStart(2, '0');
      }

      this.$axios.get(`dash-top-diagnosis`, {params})
      .then(res => {
        if (res.data.success) {
          this.header_table = res.data.data.header;
          this.data_table = res.data.data.data;
          
          this.subheader_table = [];
          this.header_table.forEach(() => {
            for(let i=0;i<2;i++) {
              this.subheader_table.push(i==0?'L':'P')
            }
          })
        }
      });
    },
    async download() {
      let params = {
        klinik_id: this.getKlinikId
      };

      if(this.periode_dt) {
        params.year = this.periode_dt.getFullYear();
        params.month = ((this.periode_dt.getMonth() + 1) + '').padStart(2, '0');
      }

      const res = await this.$axios.get(`dash-top-diagnosis/download`, { params });
      const { status, data } = res.data;

      if (status) {
        const link = document.createElement('a');
        link.href = data.link;
        link.setAttribute('download', data.name);
        document.body.appendChild(link);
        link.click();
      } else {
        this.$swal({
          type: 'error',
          text: 'Gagal Download Top 10 Diagnosis'
        })
      }
    },
    input_periode(periode) {
      this.periode_dt = periode.from;
      this.periode_name = `${periode.month} ${periode.year}`;
      this.fetchTopDiagnosis();
    },
    is_safari() {
      let userAgentString = navigator.userAgent;
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      if ((chromeAgent) && (safariAgent)) safariAgent = false;

      return safariAgent;
    }
  }
};
</script>

<style>
.app-wrapper {
  overflow-x: hidden;
}
.month-picker-input-container {
  width: 100% !important;
}
.month-picker-input {
  padding: .4em !important;
  width: 100%;
}
.month-picker__container {
  z-index: 999;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 10px;
}
</style>

<style scoped>
.table-wrapper {
  overflow-x: scroll;
}
.table-diagnosis {
  border-collapse: separate;
  border-spacing: 0;
}
.sticky {
  position: sticky;
}
.safari-only .sticky {
  position: revert;
}
tbody .sticky {
  background-color: white;
}
.r-0 {
  right: 0;
}
.r-100 {
  right: 100px;
}
.r-162 {
  right: 162px;
}
.vue-select-diagnosa {
  display: inline-block;
}
.border-l {
  border-left: 2px solid #dcdef1;
}
</style>